import React from 'react';
import { Button } from '@mui/material';
import slantArrowIcon from '../../assets/icons/slantArrowIcon.svg';

export const RedirectButton = ({
  label,
  disabled,
  onClick
}: {
  label: string;
  disabled: boolean;
  onClick: () => void;
}) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      data-testid="alternativeMeasureLink"
      endIcon={<img src={slantArrowIcon} alt="arrow" />}
      sx={{
        borderRadius: '1.25rem',
        height: '3.125rem',
        margin: '1.25rem',
        background: '#007acc',
        ':disabled': { color: 'black' }
      }}
    >
      {label}
    </Button>
  );
};
